import { css } from "@emotion/core";
import { color } from "../../constants/commons";

export const countdownStyle = css`
  color: ${color.lightishGray};
`;
